import React, {Component} from 'react'
import {formatMoney} from 'accounting-js'

export default class ShippingTypes extends Component {
  constructor(props){
    super(props);
    this.changeShipping = this.changeShipping.bind(this);
    this.finalPriceText = this.finalPriceText.bind(this);
  }

  changeShipping(event) {
    let quote = this.props.quotes.find((q) => {return q.code === event.target.value})
    this.props.onMethodSelected(quote, this.props.checkoutPath);
  }

  display_money(int_value){
    return formatMoney(int_value / 100.0);
  }

  finalPriceText(quote){
    let final_price = quote.price - this.props.shippingDiscount;
    if(final_price <= 0.0){
      return "Free"
    }
    else{
      return this.display_money(final_price);
    }
  }

  backorderFooter(backorder){
    if(backorder){
      return (
        <tfoot>
        <tr>
          <td colSpan="100%">
            <div className="alert alert-danger">
              Your order has backordered items and will ship when all items are available.
              <br/>
              <br/>
              <a href={Routes.shopping_cart_path()}>Go To Cart to split your order</a> to ship items today
            </div>
          </td>
        </tr>
        </tfoot>
      );
    }


  }



  render() {
    let t = this;

      let rows = this.props.quotes.map((q) => {
       if (!t.props.shippingDiscount == 0) {
        var priceRow = (<td align="right"><span className="shippingtable__original_price">{this.display_money(q.price)}</span>{'  '}<span className="shippingtable__final_price">{this.finalPriceText(q)}</span></td>);
       }
      else  {
        var priceRow = (<td className="shippingtable__price_column"><span className="shippingtable__final_price">{this.finalPriceText(q)}</span></td>);

      }

      return (
      <tr key={q.code}>
        <td className="shippingtable__service_name">{q.service}</td>
        <td className="shippingtable__delivery">{ this.props.backorder ? "N/A" : q.delivery_days_text}</td>
        {priceRow}
        <td className="shppingtable__radio_button"><input type="radio" checked={this.props.selectedQuote.code == q.code} name="selected_shipping" value={q.code} onChange={this.changeShipping} /></td>
      </tr>
      );
      });
    return (
        <table className="table shippingtable">
        <thead>
          <tr>
            <th>
              Service
            </th>
            <th>
              Est. Delivery
            </th>
            <th className="shippingtable__price_column">
              Price
            </th>
            <th>
            </th>
            <th>
            </th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
        {this.backorderFooter(this.props.backorder)}
        </table>
      );
  }
}
